import { render, staticRenderFns } from "./AxessOffers.vue?vue&type=template&id=49d5b5f7&scoped=true"
import script from "./AxessOffers.vue?vue&type=script&lang=js"
export * from "./AxessOffers.vue?vue&type=script&lang=js"
import style0 from "./AxessOffers.vue?vue&type=style&index=0&id=49d5b5f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5b5f7",
  null
  
)

export default component.exports